// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ValuePrincipal_wrapper__1QZwe","icon":"ValuePrincipal_icon__2ydq1","avatar":"ValuePrincipal_avatar__1volQ"};